function debounceDirective($timeout) {
    'ngInject';

    return {
        restrict: 'A',
        link(scope, element, attrs) {
            let delay = 400;
            if (attrs.bbDebounce) {
                delay = attrs.bbDebounce;
            }

            element.bind('click', () => {
                    $timeout(() => {
                            return element.attr('disabled', true);
                        }
                        , 0);
                    return $timeout(() => {
                            return element.attr('disabled', false);
                        }
                        , delay);
                }
            );
        }
    };
}

angular
    .module('BB')
    .directive('bbDebounce', debounceDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/debounce/debounce.directive.js